import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Safety() {
  const menu = [
    {
      name: "1. User Privacy and Data Security",
      id: "Safety-0",
    },
    {
      name: "2. Data Reliability",
      id: "Safety-1",
    },
    {
      name: "3. Software Security",
      id: "Safety-2",
    },
    {
      name: "4. Biosafety",
      id: "Safety-3",
    },
    {
      name: "5. Survey Policies",
      id: "Safety-4",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Safety</p>
        <ContentCard
          content={` 
            <p>
            Throughout our project, we have implemented numerous measures to guarantee safety and security.
            </p>
            `}
        />
        <p className="subtitle" key={"Safety-0"} id="Safety-0">
          1. User Privacy and Data Security:
        </p>
        <ContentCard
          content={` 
            <p>
            We have prioritized user privacy and data security. All data input by users, as well as the corresponding output, are strictly accessible only to the respective user. This ensures that users can confidently use our application without concerns about the unauthorized disclosure of their private information.
            </p>
            `}
        />
        <p className="subtitle" key={"Safety-1"} id="Safety-1">
          2. Data Reliability:
        </p>
        <ContentCard
          content={`
          <p>
          To maintain the highest ethical standards, we source our testing data from reputable open databases. This practice not only ensures data reliability but also eliminates any potential ethical concerns associated with data acquisition.
            </p>
            `}
        />
        <p className="subtitle" key={"Safety-2"} id="Safety-2">
          3. Software Security:
        </p>
        <ContentCard
          content={`
          <p>
          We have taken comprehensive measures to safeguard the security of our software. Our web application is fortified with robust security protocols, including firewall settings, to prevent any potential attacks or breaches. This ensures that users can interact with our platform securely.
            </p>
            `}
        />
        <p className="subtitle" key={"Safety-3"} id="Safety-3">
          4. Biosafety:{" "}
        </p>
        <ContentCard
          content={` 
            <p>
            In terms of biosafety, we conducted several essential procedures. Initially, we validated the effector genes in the wet lab, with TSINGKE assisting in the cloning of these genes in DH5α. Subsequently, bacterial cultures were incubated and normalized to 0.5 OD600 before undergoing serial dilution. These dilutions were then spotted onto LB agar plates containing the appropriate selection and inducer (0.2% arabinose), and the plates were left to incubate overnight at 37°C.
            </p>
            <br/>
            <p>
            During the entire experimental process, we rigorously adhered to biosafety protocols. All waste generated during the experiments was subjected to high-pressure sterilization to mitigate any potential biosafety concerns. Furthermore, before entering the laboratory, all team members actively participated in a biosafety and lab regulations lecture. This preparatory lecture was instrumental in acquainting us with potential hazards associated with our work. Our training was expertly conducted by PhD students affiliated with Dr. Siyuan Feng's lab, who covered various aspects, including the proper incubation of bacteria to prevent any lab contamination. Additionally, it's crucial to note that the genes we cloned were only expressed in the bacteria when induced. As a result, by following correct experimental procedures and practicing effective sterilization techniques, we were able to ensure that bacteria were killed and not released beyond the laboratory environment.
            </p>
            `}
        />
        <p className="subtitle" key={"Safety-4"} id="Safety-4">
          5. Survey Policies:
        </p>
        <ContentCard
          content={` 
            <p>
            Throughout our project design process, we have communicated with many people, such as professors, doctors, and companies. Prior to engaging with the public for interviews or surveys, we transparently communicate our research objectives and assure respondents that their privacy will not be compromised. When we collected data about people, such as their opinions, we have obtained their approval. Also, we have confirmed that relevant laws, regulations, and institutional rules do not require us to get formal approval.
            </p>
            `}
        />
        <br />
        <br />
        <ContentCard
          content={` 
            <p>
            These safety measures underscore our dedication to providing a secure
          and reliable platform for users while upholding ethical standards in
          all aspects of our project.
            </p>
            `}
        />
      </div>
      <Footer />
    </div>
  );
}
